import { navigate as navigateGatsby } from "gatsby";

// Warapper for gatsby navigate to include prevUrl in state
export default function navigate(to, options, ...rest) {
    const state = { ...options?.state, prevUrl: window.location.href };
    navigateGatsby(to, { ...options, state }, ...rest);
}
